import React, { useEffect } from 'react';
import { Container } from '../ui/Container';
export const ApplyPage: React.FC = () => {
  // This ensures the Typeform embed is properly initialized
  useEffect(() => {
    // Check if Typeform is loaded
    if (window.typeform) {
      window.typeform.embed.refresh();
    }
  }, []);
  return <div className="w-full min-h-full bg-dark-900 text-white" data-id="element-484">
      <div className="relative overflow-hidden" data-id="element-485">
        <div className="absolute inset-0 bg-gradient-to-br from-[#00c853]/10 to-transparent" data-id="element-486" />
        <div className="w-full py-3 text-center text-sm bg-dark-900" data-id="element-487">
          <p className="text-white/90 px-4 sm:px-0" data-id="element-488">
            <span className="inline-flex items-center gap-1.5" data-id="element-489">
              New
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="text-[#00c853]" data-id="element-490">
                <path fill="currentColor" d="M12 2l2.4 7.4h7.6l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4-6.2-4.5h7.6z" data-id="element-491" />
              </svg>
            </span>
            <span className="mx-2" data-id="element-492">·</span>
            Private equity firms, family offices, and strategic acquirers doing
            4+ acquisitions per year
          </p>
        </div>
        <div className="max-w-4xl mx-auto px-4 pt-12 pb-20 text-center relative" data-id="element-493">
          <div className="mb-8 w-48 md:w-64 mx-auto" data-id="element-494">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-495" />
          </div>
          <h1 className="text-[1.8rem] sm:text-[1.7rem] md:text-[2.5rem] lg:text-[3rem] font-bold mb-4 leading-[1.2] sm:leading-[1.15]" data-id="element-496">
            Apply For Our 'Pay On Results' Deal Sourcing Partnership (5 Slots
            ONLY)
          </h1>
          <p className="text-lg md:text-xl text-[#00c853] mb-12 italic" data-id="element-497">
            We're betting our own money on your success. Zero monthly fees. We
            only get paid when YOU close deals. Please fill out the form below
            to see if you qualify for 1 of the 5 slots.
          </p>
          {/* Typeform Embed */}
          <div data-tf-live="01K4NK8A6PFX087YPG52A0M5ZG" data-id="element-498"></div>
        </div>
      </div>
      <footer className="py-8 bg-dark-900 border-t border-dark-700" data-id="element-499">
        <Container data-id="element-500">
          <div className="text-center text-sm text-gray-400" data-id="element-501">
            © {new Date().getFullYear()} GetDealFlow.ai. All rights reserved.
          </div>
        </Container>
      </footer>
    </div>;
};